import { useSubmit } from "@certn/api";
import {
  BasicButton,
  DangerButton,
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  Modal,
  showToast,
  Text,
} from "@certn/cascadia-react";
import { css } from "@emotion/css";
import { useTranslation } from "react-i18next";

interface Props {
  onClose: () => void;
  isOpen: boolean;
  checkId?: string;
  caseId?: string;
  mutate: () => void;
}

export function CancelCheckModal(props: Props) {
  const { t } = useTranslation();
  const { onClose: close, isOpen, checkId, mutate } = props;

  const { submit } = useSubmit(
    `/api/internal/client-portal/checks/${checkId}/cancel-check/`,
    {
      throwErrors: true,
      showToastOnError: true,
      onSuccess: () => {
        showToast(t("Check cancelled"), { type: "success" });
        mutate();
      },
    }
  );

  const cancelCheck = async () => {
    close();
    await submit();
  };

  return (
    <Modal isOpen={isOpen}>
      <Dialog>
        <DialogHeader onClose={close}>
          {t("Cancel UK Criminal check")}
        </DialogHeader>
        <DialogContent>
          <div className={styles.container}>
            <Text style="global/body-primary">
              {t(
                "By cancelling the UK Criminal check, you are cancelling the submission of UK Criminal to the DBS and Identity Verification. If you require a check using digital identity verification, please order again."
              )}
            </Text>
          </div>
        </DialogContent>
        <DialogFooter>
          <BasicButton onPress={close}>{t("Close")}</BasicButton>
          <DangerButton type="submit" onPress={cancelCheck}>
            {t("Cancel check")}
          </DangerButton>
        </DialogFooter>
      </Dialog>
    </Modal>
  );
}

const styles = {
  container: css`
    padding: 16px 0;
  `,
};
